import { render, staticRenderFns } from "./check_right_copy.vue?vue&type=template&id=5727380e&scoped=true"
import script from "./check_right_copy.vue?vue&type=script&lang=js"
export * from "./check_right_copy.vue?vue&type=script&lang=js"
import style0 from "./check_right_copy.vue?vue&type=style&index=0&id=5727380e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5727380e",
  null
  
)

export default component.exports